import { SystemStyleObject } from '@betterment/samba-styled-system/types';
import { Notifications as SharedNotifications } from '@betterment/shared-components';

type Props = {
  css?: SystemStyleObject;
};

export function Notifications({ css: cssProp }: Props) {
  return <SharedNotifications css={cssProp} />;
}
